export function useSignalAbort() {
    const controller = new AbortController();
    const controllerConfig = {
        signal: controller.signal
    };
    return {controller, controllerConfig}
  }